{
  "chart": "Hồ sơ bệnh nhân",
  "mrn": "MRN",
  "demographics": {
    "pageTitle": "Thông tin nhân khẩu",
    "loading": "Đang tải thông tin nhân khẩu bệnh nhân...",
    "loadError": "Tải thông tin nhân khẩu bệnh nhân thất bại.",
    "returnToDashboard": "Quay lại trang chính",
    "updatedSuccess": "Đã cập nhật thông tin nhân khẩu bệnh nhân",
    "updateError": "Cập nhật thông tin nhân khẩu bệnh nhân thất bại",
    "sections": {
      "personalInformation": "Thông tin cá nhân",
      "identification": "Giấy tờ tùy thân",
      "contactInformation": "Thông tin liên lạc",
      "address": "Địa chỉ",
      "languageAndPreferences": "Ngôn ngữ & tùy chọn",
      "specialFlags": "Cờ đặc biệt",
      "recordInformation": "Thông tin hồ sơ"
    },
    "fields": {
      "fullName": "Họ và tên",
      "alternativeName": "Tên khác",
      "preferredName": "Tên gọi quen dùng",
      "dateOfBirth": "Ngày sinh",
      "birthTime": "Giờ sinh",
      "age": "Tuổi",
      "legalGender": "Giới tính pháp lý",
      "genderIdentity": "Bản dạng giới",
      "sexAtBirth": "Giới tính khi sinh",
      "race": "Chủng tộc",
      "ethnicity": "Dân tộc",
      "nationality": "Quốc tịch",
      "mrn": "MRN",
      "nationalIdType": "Loại giấy tờ tùy thân",
      "nationalIdNumber": "Số giấy tờ tùy thân",
      "passportNumber": "Số hộ chiếu",
      "passportCountry": "Nước cấp hộ chiếu",
      "primaryPhone": "Điện thoại chính",
      "mobilePhone": "Điện thoại di động",
      "email": "Email",
      "preferredContactMethod": "Phương thức liên lạc ưu tiên",
      "addressLine1": "Địa chỉ dòng 1",
      "addressLine2": "Địa chỉ dòng 2",
      "city": "Thành phố",
      "stateProvince": "Tỉnh/Thành",
      "postalCode": "Mã bưu chính",
      "country": "Quốc gia",
      "primaryLanguage": "Ngôn ngữ chính",
      "secondaryLanguage": "Ngôn ngữ phụ",
      "interpreterRequired": "Cần phiên dịch",
      "vipStatus": "Trạng thái VIP",
      "confidentialityLevel": "Mức độ bảo mật",
      "medicalTourist": "Du lịch y tế",
      "homeCountry": "Quốc gia gốc",
      "status": "Trạng thái",
      "deceased": "Đã qua đời",
      "created": "Ngày tạo",
      "lastModified": "Sửa lần cuối",
      "passportOnFile": "Hộ chiếu đã lưu",
      "organDonorStatus": "Tình trạng hiến tạng"
    },
    "statusValues": {
      "active": "Hoạt động",
      "inactive": "Không hoạt động"
    },
    "deceasedSummary": "Có ({{date}})",
    "deceasedDateUnknown": "Không rõ ngày",
    "legalGender": {
      "label": "Giới tính pháp lý",
      "values": {
        "male": "Nam",
        "female": "Nữ",
        "other": "Khác",
        "unknown": "Không rõ"
      },
      "selectPlaceholder": "Chọn giới tính"
    },
    "sexAtBirth": {
      "label": "Giới tính khi sinh",
      "values": {
        "female": "Nữ",
        "male": "Nam",
        "other": "Khác",
        "unknown": "Không rõ"
      },
      "notRecorded": "Chưa ghi nhận"
    },
    "preferredContactMethod": {
      "label": "Phương thức liên lạc ưu tiên",
      "values": {
        "phone": "Điện thoại",
        "mobile": "Di động",
        "email": "Email",
        "sms": "SMS"
      },
      "notSpecified": "Chưa xác định"
    },
    "validation": {
      "fullNameRequired": "Họ và tên là bắt buộc",
      "dateOfBirthRequired": "Ngày sinh là bắt buộc",
      "countryRequired": "Quốc gia là bắt buộc",
      "primaryLanguageRequired": "Ngôn ngữ chính là bắt buộc",
      "invalidEmail": "Email không hợp lệ",
      "nationalIdValidationFailed": "Xác thực số giấy tờ tùy thân thất bại: {{error}}",
      "invalidBirthTime": "Giờ sinh phải theo định dạng HH:MM"
    },
    "organDonor": {
      "notRecorded": "Chưa ghi nhận",
      "registered": "Đã đăng ký hiến",
      "optedOut": "Đã từ chối hiến",
      "notRegistered": "Chưa đăng ký",
      "unknown": "Không rõ"
    }
  },
  "registration": {
    "title": "Đăng ký bệnh nhân",
    "subtitle": "Đăng ký bệnh nhân mới vào hệ thống",
    "submit": "Đăng ký bệnh nhân",
    "submitting": "Đang đăng ký...",
    "checkingDuplicates": "Đang kiểm tra trùng lặp...",
    "registerNew": "Đăng ký bệnh nhân mới",
    "registeredSuccess": "Đăng ký bệnh nhân thành công",
    "registerError": "Đăng ký bệnh nhân thất bại",
    "validationNationalIdFailed": "Xác thực số giấy tờ tùy thân thất bại: {{error}}",
    "sections": {
      "basicInformation": "Thông tin cơ bản",
      "identification": "Giấy tờ tùy thân",
      "contactInformation": "Thông tin liên lạc",
      "address": "Địa chỉ",
      "languageAndCommunication": "Ngôn ngữ & giao tiếp",
      "additionalInformation": "Thông tin bổ sung"
    },
    "fields": {
      "facility": "Cơ sở đăng ký"
    },
    "placeholders": {
      "fullName": "Ví dụ: Nguyễn Văn A hoặc 李小明",
      "alternativeName": "Phiên âm La-tinh nếu có",
      "preferredName": "Tên bệnh nhân muốn được gọi",
      "nationalIdNumberDefault": "Nhập số giấy tờ tùy thân",
      "primaryPhone": "+84 912 345 678",
      "mobilePhone": "+84 912 345 678",
      "email": "patient@example.com",
      "facility": "Chọn cơ sở"
    },
    "helperText": {
      "fullName": "Nhập họ và tên theo giấy tờ chính thức",
      "facility": "Cơ sở nơi bệnh nhân này được đăng ký. Nhân viên tại cơ sở đó sẽ có thể mở hồ sơ."
    },
    "flags": {
      "vipPatient": "Bệnh nhân VIP",
      "medicalTourist": "Du lịch y tế"
    },
    "duplicate": {
      "title": "Phát hiện bệnh nhân có thể trùng",
      "body": "Các bệnh nhân hiện có sau đây khớp với thông tin bạn đã nhập:",
      "mrnLabel": "MRN",
      "dobLabel": "DOB",
      "idLabel": "ID",
      "matchSummary": "Độ khớp: {{score}}% ({{reasons}})",
      "useExisting": "Dùng bệnh nhân hiện có",
      "createNew": "Đây là bệnh nhân mới",
      "restricted": {
        "title_one": "Có {{count}} kết quả có thể trùng khớp mà bạn không có quyền xem",
        "title_other": "Có {{count}} kết quả có thể trùng khớp mà bạn không có quyền xem",
        "body": "Bệnh nhân này có thể đã có hồ sơ tại cơ sở khác. Hãy liên hệ bộ phận Quản lý Thông tin Y tế trước khi tạo hồ sơ mới — chi tiết được ẩn vì hồ sơ nằm ngoài quyền truy cập của bạn."
      },
      "overrideReasonLabel": "Lý do vẫn đăng ký",
      "overrideReasonPlaceholder": "vd. đã xác nhận với bệnh nhân rằng đây là người khác",
      "overrideReasonHelp": "Được ghi lại theo tài khoản của bạn. Tạo hồ sơ thứ hai cho cùng một người sẽ làm phân tán bệnh án.",
      "registerAnyway": "Vẫn đăng ký"
    }
  },
  "search": {
    "title": "Tìm bệnh nhân",
    "subtitle": "Tìm và quản lý hồ sơ bệnh nhân",
    "placeholder": "Tìm theo tên bệnh nhân, MRN hoặc ID...",
    "advancedFilters": "Bộ lọc nâng cao",
    "filters": {
      "mrnPlaceholder": "Ví dụ: P0000000001",
      "fullNamePlaceholder": "Tên bệnh nhân",
      "phonePlaceholder": "Số điện thoại",
      "emailPlaceholder": "Địa chỉ email"
    },
    "filterLabels": {
      "mrn": "MRN",
      "fullName": "Họ và tên",
      "dateOfBirth": "Ngày sinh",
      "phone": "Điện thoại",
      "email": "Email",
      "country": "Quốc gia",
      "status": "Trạng thái",
      "vip": "VIP"
    },
    "vipFilter": {
      "all": "Tất cả",
      "vipOnly": "Chỉ VIP",
      "nonVipOnly": "Chỉ không VIP"
    },
    "statusFilter": {
      "all": "Tất cả",
      "active": "Hoạt động",
      "inactive": "Không hoạt động"
    },
    "countryFilter": {
      "all": "Tất cả quốc gia"
    },
    "clearFilters": "Xóa bộ lọc",
    "dateOfBirthAria": "Bộ lọc ngày sinh",
    "columns": {
      "mrn": "MRN",
      "fullName": "Họ và tên",
      "dob": "DOB",
      "gender": "Giới tính",
      "phone": "Điện thoại",
      "country": "Quốc gia",
      "status": "Trạng thái"
    },
    "results": {
      "searching": "Đang tìm bệnh nhân...",
      "loadError": "Tải bệnh nhân thất bại. Vui lòng thử lại.",
      "retry": "Thử lại",
      "empty": "Không tìm thấy bệnh nhân. Vui lòng điều chỉnh tiêu chí tìm kiếm.",
      "showing": "Hiển thị {{from}} – {{to}} trên tổng số {{total}} bệnh nhân"
    }
  },
  "myPatients": {
    "title": "Bệnh nhân của tôi",
    "subtitle": "Bệnh nhân đang điều trị do bạn phụ trách",
    "searchPlaceholder": "Lọc theo tên hoặc MRN...",
    "columns": {
      "mrn": "MRN",
      "patient": "Họ và tên",
      "dob": "DOB",
      "sex": "Giới tính",
      "class": "Phân loại",
      "relationship": "Mối quan hệ",
      "admitted": "Ngày nhập viện"
    },
    "kind": {
      "attending": "Điều trị",
      "careTeam": "Nhóm chăm sóc",
      "referral": "Chuyển tuyến",
      "coverage": "Trực thay"
    },
    "restrictedBadge": "Hạn chế",
    "empty": {
      "title": "Bảng của bạn chưa có bệnh nhân",
      "body": "Bệnh nhân bạn điều trị, trực thay hoặc tiếp nhận chuyển tuyến sẽ hiện ở đây.",
      "censusAction": "Mở bảng giường"
    },
    "results": {
      "searching": "Đang tải bệnh nhân của bạn...",
      "loadError": "Tải bệnh nhân của bạn thất bại. Vui lòng thử lại.",
      "retry": "Thử lại",
      "showing": "Hiển thị {{from}} – {{to}} trên tổng số {{total}} bệnh nhân"
    }
  },
  "encounters": {
    "title": "Lần khám",
    "create": "Tạo lần khám",
    "filters": "Bộ lọc",
    "filterLabels": {
      "status": "Trạng thái",
      "class": "Phân loại",
      "fromDate": "Từ ngày",
      "toDate": "Đến ngày"
    },
    "filterPlaceholders": {
      "allStatuses": "Tất cả trạng thái",
      "allClasses": "Tất cả phân loại"
    },
    "clearFilters": "Xóa bộ lọc",
    "fromDateAria": "Từ ngày",
    "toDateAria": "Đến ngày",
    "columns": {
      "encounterNumber": "Số lần khám",
      "class": "Phân loại",
      "status": "Trạng thái",
      "admitDate": "Ngày nhập viện",
      "dischargeDate": "Ngày xuất viện",
      "location": "Vị trí",
      "chiefComplaint": "Lý do khám"
    },
    "locationLabel": "Vị trí #{{id}}",
    "loading": "Đang tải lần khám...",
    "loadError": "Tải lần khám thất bại.",
    "empty": "Bệnh nhân này chưa có lần khám nào.",
    "showing": "Hiển thị {{from}} – {{to}} trên tổng số {{total}}"
  },
  "identifiers": {
    "nationalIdType": {
      "label": "Loại giấy tờ tùy thân",
      "none": "Không",
      "values": {
        "nric": "NRIC",
        "hkid": "HKID",
        "myKad": "MyKad",
        "aadhaar": "Aadhaar",
        "ktp": "KTP",
        "myNumber": "My Number",
        "thaiNationalId": "CMND Thái Lan"
      },
      "country": {
        "nric": "Singapore",
        "hkid": "Hồng Kông",
        "myKad": "Malaysia",
        "aadhaar": "Ấn Độ",
        "ktp": "Indonesia",
        "myNumber": "Nhật Bản",
        "thaiNationalId": "Thái Lan"
      },
      "placeholderByType": {
        "nric": "Ví dụ: S1234567D",
        "myKad": "Ví dụ: 850101-14-5678",
        "hkid": "Ví dụ: A123456(3)",
        "aadhaar": "Ví dụ: 2341 2341 2346",
        "thaiNationalId": "Ví dụ: 1-2345-45678-78-1"
      }
    },
    "nationalIdCheck": {
      "checksumMismatch": "Ký tự kiểm tra không khớp với loại giấy tờ này. Hãy đối chiếu số với giấy tờ tùy thân của bệnh nhân.",
      "unavailable": "Không thể kiểm tra số giấy tờ này. Hãy đối chiếu số với giấy tờ tùy thân của bệnh nhân.",
      "acknowledge": "Tôi đã đối chiếu số này với giấy tờ tùy thân",
      "acknowledgeRequired": "Hãy đối chiếu số giấy tờ tùy thân và xác nhận trước khi lưu."
    }
  },
  "country": {
    "values": {
      "sg": "Singapore",
      "my": "Malaysia",
      "th": "Thái Lan",
      "id": "Indonesia",
      "ph": "Philippines",
      "vn": "Việt Nam",
      "hk": "Hồng Kông",
      "tw": "Đài Loan",
      "jp": "Nhật Bản",
      "kr": "Hàn Quốc",
      "cn": "Trung Quốc",
      "in": "Ấn Độ",
      "au": "Úc",
      "nz": "New Zealand"
    }
  },
  "language": {
    "values": {
      "en": "Tiếng Anh",
      "zh": "Tiếng Trung (Quan thoại)",
      "ms": "Tiếng Mã Lai",
      "ta": "Tiếng Tamil",
      "th": "Tiếng Thái",
      "id": "Tiếng Indonesia",
      "vi": "Tiếng Việt",
      "ja": "Tiếng Nhật",
      "ko": "Tiếng Hàn",
      "hi": "Tiếng Hindi"
    }
  },
  "contact": {
    "addTitle": "Thêm Liên hệ",
    "editTitle": "Chỉnh sửa Liên hệ",
    "name": "Họ tên",
    "relationship": {
      "label": "Quan hệ",
      "selectPlaceholder": "Chọn...",
      "values": {
        "spouse": "Vợ/Chồng",
        "parent": "Cha/Mẹ",
        "child": "Con",
        "sibling": "Anh/Chị/Em",
        "guardian": "Người giám hộ",
        "friend": "Bạn",
        "other": "Khác"
      }
    },
    "phone": "Điện thoại",
    "email": "Email",
    "emergencyContact": "Liên hệ khẩn cấp",
    "validation": {
      "nameRequired": "Vui lòng nhập họ tên liên hệ",
      "relationshipRequired": "Vui lòng chọn quan hệ",
      "phoneRequired": "Vui lòng nhập số điện thoại",
      "invalidEmail": "Email không hợp lệ"
    },
    "savedSuccess": "Đã thêm liên hệ thành công",
    "saveError": "Thêm liên hệ thất bại"
  },
  "immunization": {
    "addTitle": "Thêm Tiêm chủng",
    "vaccineName": "Tên vắc-xin",
    "vaccineNamePlaceholder": "Ví dụ: Cúm, COVID-19 (Pfizer), Viêm gan B",
    "vaccineCode": "Mã vắc-xin (CVX)",
    "vaccineCodePlaceholder": "Ví dụ: 141",
    "administeredDate": "Ngày tiêm",
    "lotNumber": "Số lô",
    "lotNumberPlaceholder": "Ví dụ: AB1234",
    "site": {
      "label": "Vị trí",
      "selectPlaceholder": "Chọn vị trí",
      "values": {
        "leftDeltoid": "Cơ delta trái",
        "rightDeltoid": "Cơ delta phải",
        "leftThigh": "Đùi trái",
        "rightThigh": "Đùi phải",
        "leftGluteal": "Mông trái",
        "rightGluteal": "Mông phải",
        "other": "Khác"
      }
    },
    "route": {
      "label": "Đường dùng",
      "selectPlaceholder": "Chọn đường dùng",
      "values": {
        "intramuscular": "Tiêm bắp (IM)",
        "subcutaneous": "Tiêm dưới da (SC)",
        "intradermal": "Tiêm trong da (ID)",
        "oral": "Uống",
        "intranasal": "Xịt mũi"
      }
    },
    "doseAmount": "Liều lượng",
    "doseAmountPlaceholder": "Ví dụ: 0.5 mL",
    "administeredBy": "Người tiêm",
    "administeredByPlaceholder": "Tên hoặc mã nhân viên y tế",
    "nextDueDate": "Ngày tiêm tiếp theo",
    "notes": "Ghi chú",
    "notesPlaceholder": "Ghi chú bổ sung...",
    "validation": {
      "vaccineNameRequired": "Vui lòng nhập tên vắc-xin",
      "administeredDateRequired": "Vui lòng nhập ngày tiêm"
    },
    "savedSuccess": "Đã thêm hồ sơ tiêm chủng",
    "saveError": "Thêm hồ sơ tiêm chủng thất bại"
  },
  "insurance": {
    "addTitle": "Thêm Gói Bảo hiểm",
    "submitLabel": "Thêm Bảo hiểm",
    "payerName": "Tên đơn vị chi trả",
    "payerNamePlaceholder": "Ví dụ: AIA Singapore",
    "payerId": "Mã đơn vị chi trả",
    "payerIdPlaceholder": "Mã định danh đơn vị chi trả",
    "planName": "Tên gói",
    "planNamePlaceholder": "Ví dụ: HealthShield Gold Max",
    "planType": {
      "label": "Loại gói",
      "selectPlaceholder": "Chọn loại",
      "values": {
        "hmo": "HMO",
        "ppo": "PPO",
        "epo": "EPO",
        "pos": "POS",
        "government": "Nhà nước",
        "private": "Tư nhân",
        "corporate": "Doanh nghiệp",
        "other": "Khác"
      }
    },
    "memberId": "Mã thành viên",
    "memberIdPlaceholder": "Số mã thành viên",
    "policyNumber": "Số hợp đồng bảo hiểm",
    "policyNumberPlaceholder": "Nhập số hợp đồng bảo hiểm",
    "groupNumber": "Số nhóm",
    "groupNumberPlaceholder": "Số nhóm",
    "subscriberName": "Tên người tham gia",
    "subscriberNamePlaceholder": "Nếu khác với bệnh nhân",
    "subscriberRelationship": {
      "label": "Quan hệ với người tham gia",
      "values": {
        "self": "Bản thân",
        "spouse": "Vợ/Chồng",
        "child": "Con",
        "parent": "Cha/Mẹ",
        "other": "Khác"
      }
    },
    "priority": {
      "label": "Ưu tiên",
      "values": {
        "primary": "Chính",
        "secondary": "Phụ",
        "tertiary": "Bậc ba"
      }
    },
    "effectiveDate": "Ngày hiệu lực",
    "terminationDate": "Ngày kết thúc",
    "copayAmount": "Đồng chi trả ($)",
    "coinsurancePercent": "Đồng bảo hiểm (%)",
    "deductibleAmount": "Mức khấu trừ ($)",
    "outOfPocketMax": "Mức tự chi tối đa ($)",
    "preAuthRequired": "Yêu cầu phê duyệt trước",
    "notes": "Ghi chú",
    "notesPlaceholder": "Ghi chú bổ sung...",
    "validation": {
      "payerNameRequired": "Vui lòng nhập tên đơn vị chi trả",
      "planNameRequired": "Vui lòng nhập tên gói",
      "memberIdRequired": "Vui lòng nhập mã thành viên",
      "effectiveDateRequired": "Vui lòng nhập ngày hiệu lực"
    },
    "savedSuccess": "Đã thêm gói bảo hiểm",
    "saveError": "Thêm gói bảo hiểm thất bại"
  },
  "problem": {
    "addTitle": "Thêm Vấn đề",
    "problemName": "Tên vấn đề",
    "problemNamePlaceholder": "Ví dụ: Đái tháo đường tuýp 2",
    "icdCode": "Mã ICD-10",
    "icdSearchPlaceholder": "Tìm mã ICD-10 hoặc mô tả...",
    "onsetDate": "Ngày khởi phát",
    "severity": {
      "label": "Mức độ",
      "values": {
        "mild": "Nhẹ",
        "moderate": "Trung bình",
        "severe": "Nặng"
      }
    },
    "notes": "Ghi chú",
    "notesPlaceholder": "Ghi chú lâm sàng bổ sung...",
    "validation": {
      "problemNameRequired": "Vui lòng nhập tên vấn đề"
    },
    "savedSuccess": "Đã thêm vấn đề vào danh sách",
    "saveError": "Thêm vấn đề thất bại"
  },
  "accounts": {
    "pageTitle": "Tài khoản Bệnh nhân",
    "backToDashboard": "Bảng điều khiển",
    "searchPatientLabel": "Tìm bệnh nhân",
    "searchPlaceholder": "Tìm theo tên hoặc MRN...",
    "searching": "Đang tìm...",
    "noPatientsFound": "Không tìm thấy bệnh nhân",
    "loadingAccount": "Đang tải tài khoản...",
    "mrnLabel": "MRN",
    "generateStatement": "Tạo bảng kê",
    "statementComingSoon": "Tính năng tạo bảng kê sắp ra mắt",
    "paymentPlan": "Kế hoạch thanh toán",
    "paymentPlanComingSoon": "Thiết lập kế hoạch thanh toán sắp ra mắt",
    "totalCharges": "Tổng phí",
    "totalPayments": "Tổng thanh toán",
    "adjustments": "Điều chỉnh",
    "outstandingBalance": "Số dư còn lại",
    "transactionHistory": "Lịch sử Giao dịch",
    "columns": {
      "date": "Ngày",
      "type": "Loại",
      "description": "Mô tả",
      "amount": "Số tiền",
      "balance": "Số dư"
    },
    "transactionType": {
      "label": "Loại",
      "values": {
        "charge": "Phí",
        "payment": "Thanh toán",
        "adjustment": "Điều chỉnh"
      }
    },
    "loadingTransactions": "Đang tải giao dịch...",
    "noTransactionsFound": "Không có giao dịch",
    "emptyState": "Tìm bệnh nhân để xem tài khoản"
  },
  "proxies": {
    "title": "Người đại diện ủy quyền",
    "description": "Người chăm sóc, người giám hộ và đại diện pháp lý được ủy quyền truy cập dữ liệu cổng thông tin của bệnh nhân. Các mục đã thu hồi được giữ lại để kiểm toán.",
    "addProxy": "Thêm Người đại diện",
    "newRelationshipHeading": "Quan hệ đại diện mới",
    "proxyUserId": "ID người dùng đại diện",
    "proxyUserIdPlaceholder": "ID người dùng (từ Quản trị → Người dùng)",
    "proxyUserIdHelper": "Tra cứu trong Quản trị → Người dùng. Thành phần chọn người dùng sẽ có trong bản phát hành tiếp theo.",
    "relationship": {
      "label": "Quan hệ",
      "values": {
        "parent": "Cha/Mẹ",
        "legalGuardian": "Người giám hộ hợp pháp",
        "spousePartner": "Vợ/Chồng / Bạn đời",
        "adultChild": "Con đã trưởng thành",
        "powerOfAttorney": "Người được ủy quyền",
        "healthcareAgent": "Đại diện y tế"
      }
    },
    "accessLevel": {
      "label": "Mức truy cập",
      "values": {
        "full": "Đầy đủ",
        "limited": "Hạn chế",
        "emergency": "Khẩn cấp"
      },
      "descriptions": {
        "full": "Toàn bộ dữ liệu cổng — cuộc hẹn, kết quả, tin nhắn, biểu mẫu.",
        "limited": "Chỉ cuộc hẹn và tin nhắn (thường dành cho thanh thiếu niên).",
        "emergency": "Truy cập khẩn cấp tương đương break-glass cho đại diện y tế khi bệnh nhân mất năng lực."
      }
    },
    "startDate": "Ngày bắt đầu",
    "endDate": "Ngày kết thúc",
    "startDateAria": "Ngày bắt đầu hiệu lực",
    "endDateAria": "Ngày kết thúc hiệu lực",
    "grantAccess": "Cấp quyền truy cập đại diện",
    "userIdRequired": "Yêu cầu ID người dùng đại diện",
    "createdSuccess": "Đã tạo quan hệ đại diện",
    "duplicateError": "Người này đã là đại diện với quan hệ đó",
    "invalidDataError": "Dữ liệu đại diện không hợp lệ",
    "createError": "Tạo đại diện thất bại",
    "revokedSuccess": "Đã thu hồi quyền truy cập đại diện",
    "revokeError": "Thu hồi đại diện thất bại",
    "emptyState": "Chưa cấu hình đại diện. Sử dụng nút phía trên để cấp quyền cho người chăm sóc, người giám hộ hoặc đại diện y tế.",
    "sections": {
      "active": "Đang hoạt động ({{count}})",
      "plannedInactive": "Dự kiến / Không hoạt động ({{count}})",
      "revoked": "Đã thu hồi ({{count}})"
    },
    "userIdFallback": "Người dùng #{{id}}",
    "noEndDate": "(không có ngày kết thúc)",
    "revokedOn": "Đã thu hồi {{date}}",
    "revokeTitle": "Thu hồi quyền truy cập đại diện",
    "confirmRevokeTitle": "Thu hồi quyền truy cập đại diện?",
    "confirmRevokeBody": "{{name}} sẽ mất quyền truy cập dữ liệu cổng thông tin của bệnh nhân ngay lập tức. Bản ghi sẽ được giữ lại trong nhật ký kiểm toán.",
    "confirmRevokeLabel": "Thu hồi truy cập"
  },
  "merge": {
    "title": "Hợp nhất Bệnh nhân",
    "description": "Hợp nhất các hồ sơ bệnh nhân trùng lặp. Bệnh nhân nguồn sẽ bị vô hiệu hóa và toàn bộ dữ liệu lâm sàng sẽ được chuyển sang bệnh nhân đích (được giữ lại).",
    "sourceLabel": "Bệnh nhân nguồn (sẽ bị vô hiệu hóa)",
    "targetLabel": "Bệnh nhân đích (hồ sơ được giữ lại)",
    "clearSelection": "Xóa lựa chọn",
    "searchPlaceholder": "Tìm theo tên, MRN hoặc điện thoại...",
    "fields": {
      "mrn": "MRN",
      "dob": "Ngày sinh",
      "gender": "Giới tính",
      "country": "Quốc gia",
      "phone": "Điện thoại",
      "email": "Email"
    },
    "counts": {
      "encounters": "Lần khám: {{count}}",
      "allergies": "Dị ứng: {{count}}",
      "problems": "Vấn đề: {{count}}"
    },
    "samePatientWarning": "Bệnh nhân nguồn và đích phải khác nhau.",
    "comparisonTitle": "So sánh Thông tin Cá nhân",
    "comparisonSubtitle": "Sự khác biệt được tô màu hổ phách.",
    "columns": {
      "field": "Trường",
      "source": "Nguồn ({{mrn}})",
      "target": "Đích ({{mrn}})"
    },
    "comparisonLabels": {
      "fullName": "Họ và tên",
      "mrn": "MRN",
      "dateOfBirth": "Ngày sinh",
      "gender": "Giới tính",
      "phone": "Điện thoại",
      "email": "Email",
      "country": "Quốc gia",
      "nationalId": "Mã số quốc gia"
    },
    "reasonLabel": "Lý do hợp nhất",
    "reasonPlaceholder": "Lý do hợp nhất các hồ sơ này (bắt buộc)",
    "notesLabel": "Ghi chú (tùy chọn)",
    "notesPlaceholder": "Ghi chú bổ sung về lần hợp nhất này",
    "mergeButton": "Hợp nhất Bệnh nhân",
    "mergeSuccess": "Hợp nhất bệnh nhân thành công",
    "mergeError": "Hợp nhất bệnh nhân thất bại",
    "successHeading": "Hợp nhất hoàn tất thành công.",
    "successBodyPrefix": "Bệnh nhân {{mrn}} đã bị vô hiệu hóa. Toàn bộ dữ liệu lâm sàng đã được chuyển sang ",
    "successBodySuffix": ".",
    "confirmTitle": "Xác nhận Hợp nhất Bệnh nhân",
    "confirmBodyPrefix": "Hành động này ",
    "confirmBodyEmphasis": "KHÔNG THỂ hoàn tác",
    "confirmBodySuffix": ". Bệnh nhân {{sourceMrn}} ({{sourceName}}) sẽ bị vô hiệu hóa và toàn bộ dữ liệu lâm sàng sẽ được chuyển sang bệnh nhân {{targetMrn}} ({{targetName}}).",
    "confirmButton": "Xác nhận Hợp nhất",
    "swapSides": "Swap source and target",
    "preloadError": "Could not load the selected records.",
    "detailLoadError": "Không thể tải hồ sơ bệnh nhân."
  },
  "allergy": {
    "addTitle": "Thêm dị ứng",
    "editTitle": "Sửa dị ứng",
    "allergen": "Tác nhân gây dị ứng",
    "allergenPlaceholder": "Ví dụ: Penicillin, Đậu phộng",
    "type": "Loại",
    "typeOptions": {
      "drug": "Thuốc",
      "food": "Thực phẩm",
      "environmental": "Môi trường"
    },
    "severityLabel": "Mức độ",
    "severity": {
      "mild": "Nhẹ",
      "moderate": "Trung bình",
      "severe": "Nặng",
      "lifeThreatening": "Đe dọa tính mạng"
    },
    "reaction": "Phản ứng",
    "reactionPlaceholder": "Ví dụ: Mề đay, Sốc phản vệ, Buồn nôn",
    "reactionOptions": {
      "rash": "Phát ban",
      "hives": "Mề đay",
      "anaphylaxis": "Sốc phản vệ",
      "swelling": "Sưng tấy",
      "itching": "Ngứa",
      "other": "Khác"
    },
    "onsetDate": "Ngày khởi phát",
    "notes": "Ghi chú",
    "notesPlaceholder": "Ghi chú bổ sung...",
    "verifiedBy": "Người xác nhận",
    "noKnownAllergies": "Không có dị ứng đã biết",
    "savedSuccess": "Đã thêm dị ứng thành công",
    "saveError": "Không thể thêm dị ứng",
    "deletedSuccess": "Đã xóa dị ứng"
  },
  "components": {
    "allergyBadge": {
      "title": "{{name}} ({{type}}) - {{severity}}"
    },
    "bradenScale": {
      "title": "Thang Braden (nguy cơ loét tì đè)",
      "footer": "Khoảng tổng điểm: 6-23. Điểm càng thấp thì nguy cơ loét tì đè càng cao.",
      "scoreFormat": "Điểm: {{score}} — {{riskBand}}",
      "riskBand": {
        "veryHigh": "Nguy cơ rất cao",
        "high": "Nguy cơ cao",
        "moderate": "Nguy cơ trung bình",
        "mild": "Nguy cơ nhẹ",
        "none": "Không có nguy cơ"
      },
      "subscales": {
        "sensoryPerception": {
          "label": "{{n}}. Cảm nhận giác quan",
          "options": {
            "1": "{{n}} - Hạn chế hoàn toàn",
            "2": "{{n}} - Hạn chế nhiều",
            "3": "{{n}} - Hạn chế nhẹ",
            "4": "{{n}} - Không suy giảm"
          }
        },
        "moisture": {
          "label": "{{n}}. Độ ẩm",
          "options": {
            "1": "{{n}} - Ẩm ướt liên tục",
            "2": "{{n}} - Rất ẩm",
            "3": "{{n}} - Thỉnh thoảng ẩm",
            "4": "{{n}} - Hiếm khi ẩm"
          }
        },
        "activity": {
          "label": "{{n}}. Mức vận động",
          "options": {
            "1": "{{n}} - Nằm liệt giường",
            "2": "{{n}} - Ngồi ghế",
            "3": "{{n}} - Thỉnh thoảng đi lại",
            "4": "{{n}} - Đi lại thường xuyên"
          }
        },
        "mobility": {
          "label": "{{n}}. Khả năng di chuyển",
          "options": {
            "1": "{{n}} - Hoàn toàn bất động",
            "2": "{{n}} - Hạn chế nhiều",
            "3": "{{n}} - Hạn chế nhẹ",
            "4": "{{n}} - Không hạn chế"
          }
        },
        "nutrition": {
          "label": "{{n}}. Dinh dưỡng",
          "options": {
            "1": "{{n}} - Rất kém",
            "2": "{{n}} - Có thể không đủ",
            "3": "{{n}} - Đầy đủ",
            "4": "{{n}} - Tuyệt vời"
          }
        },
        "frictionShear": {
          "label": "{{n}}. Ma sát và lực cắt",
          "options": {
            "1": "{{n}} - Có vấn đề",
            "2": "{{n}} - Có thể có vấn đề",
            "3": "{{n}} - Không có vấn đề rõ ràng"
          }
        }
      }
    },
    "morseFallScale": {
      "title": "Thang điểm Té ngã Morse",
      "scoreFormat": "Điểm: {{score}} — {{riskBand}}",
      "subscales": {
        "historyOfFalling": {
          "label": "{{n}}. Tiền sử té ngã",
          "options": {
            "0": "Không ({{score}})",
            "25": "Có ({{score}})"
          }
        },
        "secondaryDiagnosis": {
          "label": "{{n}}. Chẩn đoán phụ",
          "options": {
            "0": "Không ({{score}})",
            "15": "Có ({{score}})"
          }
        },
        "ambulatoryAid": {
          "label": "{{n}}. Dụng cụ hỗ trợ đi lại",
          "options": {
            "0": "Không có / Nghỉ tại giường / Điều dưỡng hỗ trợ ({{score}})",
            "15": "Nạng / Gậy / Khung tập đi ({{score}})",
            "30": "Tựa vào đồ đạc ({{score}})"
          }
        },
        "ivHeparinLock": {
          "label": "{{n}}. Tiêm tĩnh mạch / Khóa Heparin",
          "options": {
            "0": "Không ({{score}})",
            "20": "Có ({{score}})"
          }
        },
        "gait": {
          "label": "{{n}}. Dáng đi",
          "options": {
            "0": "Bình thường / Nghỉ tại giường / Xe lăn ({{score}})",
            "10": "Yếu ({{score}})",
            "20": "Suy giảm ({{score}})"
          }
        },
        "mentalStatus": {
          "label": "{{n}}. Trạng thái tinh thần",
          "options": {
            "0": "Nhận thức đúng khả năng của bản thân ({{score}})",
            "15": "Đánh giá quá cao / Quên giới hạn ({{score}})"
          }
        }
      },
      "interventions": {
        "high": "Can thiệp nguy cơ cao: Thực hiện các biện pháp phòng ngừa té ngã tiêu chuẩn. Đeo vòng tay cảnh báo nguy cơ té ngã cho bệnh nhân. Treo biển báo nguy cơ té ngã tại giường. Giáo dục bệnh nhân và gia đình. Giữ giường ở vị trí thấp nhất và khóa phanh. Đảm bảo chuông gọi trong tầm với. Giày chống trượt. Lịch đi vệ sinh. Cân nhắc giám sát 1:1 nếu cần.",
        "moderate": "Can thiệp nguy cơ trung bình: Thực hiện các biện pháp phòng ngừa té ngã tiêu chuẩn. Đeo vòng tay cảnh báo nguy cơ té ngã cho bệnh nhân. Giáo dục bệnh nhân và gia đình. Giữ giường ở vị trí thấp nhất và khóa phanh. Đảm bảo chuông gọi trong tầm với. Giày chống trượt.",
        "low": "Can thiệp nguy cơ thấp: Chăm sóc điều dưỡng cơ bản tốt. Giáo dục bệnh nhân về di chuyển an toàn. Định hướng môi trường và cách sử dụng chuông gọi."
      }
    }
  },
  "banner": {
    "label": "Thông tin bệnh nhân",
    "vip": "VIP",
    "vipTitle": "Bệnh nhân VIP",
    "mrn": "MRN",
    "dob": "DOB",
    "ageSuffix": "t",
    "sex": "Giới tính",
    "codeStatusAria": "Mã cấp cứu: {{status}}",
    "isolationAria": "Cách ly: {{status}}",
    "isolation": {
      "contact": "Tiếp xúc",
      "droplet": "Giọt bắn",
      "airborne": "Không khí",
      "none": "Không"
    },
    "fallRiskAria": "Nguy cơ té ngã: {{level}}",
    "fallRisk": {
      "label": "Nguy cơ té ngã",
      "low": "Thấp",
      "moderate": "Trung bình",
      "high": "Cao"
    },
    "pressureInjuryRisk": "Nguy cơ loét tì đè",
    "pressureInjuryRiskAria": "Nguy cơ loét tì đè: {{level}}",
    "interpreter": "Phiên dịch",
    "interpreterRequired": "Cần phiên dịch — {{language}}",
    "languageNotSpecified": "chưa chỉ định ngôn ngữ",
    "weightKg": "{{weight}} kg",
    "allergiesLabel": "Dị ứng",
    "moreAllergies_one": "+{{count}} nữa",
    "moreAllergies_other": "+{{count}} nữa",
    "nkda": "NKDA",
    "allergiesUnknown": "Dị ứng chưa rõ — tải thất bại"
  },
  "chartFrame": {
    "navAriaLabel": "Điều hướng hồ sơ bệnh nhân",
    "tabs": {
      "summary": "Tóm tắt",
      "encounters": "Lần khám",
      "orders": "Y lệnh",
      "results": "Kết quả",
      "medications": "Thuốc",
      "notes": "Ghi chú",
      "problems": "Danh sách vấn đề",
      "allergies": "Dị ứng",
      "immunizations": "Tiêm chủng",
      "intakeOutput": "Lưu lượng",
      "carePlans": "Kế hoạch chăm sóc",
      "referrals": "Chuyển tuyến",
      "familyHistory": "Tiền sử gia đình",
      "socialHistory": "Tiền sử xã hội",
      "surgicalHistory": "Tiền sử phẫu thuật",
      "advanceDirectives": "Chỉ thị trước",
      "insurance": "Bảo hiểm",
      "contacts": "Liên hệ",
      "proxies": "Người đại diện",
      "identifiers": "Mã định danh",
      "addresses": "Địa chỉ",
      "consents": "Consents",
      "pregnancyStatus": "Pregnancy",
      "implantableDevices": "Thiết bị",
      "ccdaImports": "Nhập C-CDA"
    },
    "groups": {
      "clinical": "Lâm sàng",
      "history": "Tiền sử",
      "admin": "Quản trị"
    },
    "breakGlass": {
      "auditBanner": "TRUY CẬP KHẨN CẤP — Mọi hoạt động đang được kiểm toán. Quyền truy cập sẽ hết hạn sau 15 phút.",
      "dialogTitle": "Hồ sơ bệnh nhân hạn chế",
      "dialogSubtitle": "Cần quyền truy cập khẩn cấp",
      "dialogBody": "Hồ sơ bệnh nhân này bị hạn chế. Bạn phải cung cấp lý do để truy cập. Mọi truy cập khẩn cấp đều được ghi nhận và kiểm toán.",
      "justificationLabel": "Lý do truy cập",
      "justificationPlaceholder": "Nhập lý do lâm sàng để truy cập hồ sơ hạn chế này...",
      "justificationRequired": "Cần có lý do để truy cập khẩn cấp.",
      "requestError": "Yêu cầu truy cập khẩn cấp thất bại. Vui lòng thử lại hoặc liên hệ quản trị viên.",
      "submitButton": "Truy cập hồ sơ",
      "submitting": "Đang yêu cầu...",
      "passwordLabel": "Xác nhận mật khẩu của bạn",
      "passwordPlaceholder": "Nhập lại mật khẩu của bạn",
      "passwordRequired": "Cần mật khẩu của bạn để truy cập khẩn cấp.",
      "passwordIncorrect": "Mật khẩu không đúng. Vui lòng thử lại.",
      "passwordHelp": "Xác nhận chính bạn đang ở máy trạm này.",
      "totpLabel": "Mã xác thực",
      "totpPlaceholder": "Mã 6 chữ số",
      "totpRequired": "Cần mã xác thực của bạn để truy cập khẩn cấp.",
      "totpIncorrect": "Mã không đúng. Vui lòng thử lại.",
      "totpHelp": "Xác nhận chính bạn đang ở máy trạm này.",
      "totpEnrollHint": "Chưa đăng ký ứng dụng xác thực — hãy đăng ký trong Hồ sơ của tôi để dùng truy cập khẩn cấp."
    },
    "invalidId": {
      "title": "Mã bệnh nhân không hợp lệ",
      "body": "Mã bệnh nhân được cung cấp không hợp lệ.",
      "action": "Tìm bệnh nhân"
    },
    "notFound": {
      "title": "Không tìm thấy bệnh nhân",
      "body": "Không thể tải dữ liệu bệnh nhân. Bệnh nhân có thể không tồn tại hoặc bạn không có quyền truy cập.",
      "action": "Tìm bệnh nhân"
    },
    "loadError": {
      "title": "Không tải được biểu đồ bệnh nhân",
      "body": "Không thể tải biểu đồ. Vui lòng thử lại.",
      "action": "Thử lại"
    }
  },
  "address": {
    "title": "Địa chỉ",
    "addAddress": "Thêm địa chỉ",
    "newTitle": "Địa chỉ mới",
    "editTitle": "Sửa địa chỉ",
    "loading": "Đang tải địa chỉ...",
    "loadError": "Không tải được thông tin địa chỉ.",
    "empty": "Chưa có địa chỉ nào.",
    "addressType": {
      "label": "Loại",
      "values": {
        "home": "Nhà riêng",
        "work": "Cơ quan",
        "temporary": "Tạm trú",
        "billing": "Thanh toán"
      }
    },
    "fields": {
      "addressLine1": "Địa chỉ dòng 1",
      "addressLine2": "Địa chỉ dòng 2",
      "addressLine3": "Địa chỉ dòng 3",
      "district": "Quận/huyện",
      "city": "Thành phố",
      "stateProvince": "Tỉnh/thành",
      "postalCode": "Mã bưu chính",
      "country": "Quốc gia"
    },
    "placeholders": {
      "addressLine1": "Số nhà, đường",
      "addressLine2": "Căn hộ, đơn nguyên, tầng",
      "addressLine3": "Tòa nhà, khu",
      "district": "Quận/phường",
      "postalCode": "ví dụ: 100000",
      "country": "ví dụ: VN"
    },
    "primaryBadge": "Chính",
    "setPrimary": "Đặt làm địa chỉ chính",
    "primaryHelper": "(các địa chỉ khác sẽ không còn là chính)",
    "fromLabel": "Từ: {{date}}",
    "toLabel": "Đến: {{date}}",
    "save": "Lưu",
    "update": "Cập nhật",
    "cancel": "Hủy",
    "editTooltip": "Sửa địa chỉ",
    "removeTooltip": "Xóa địa chỉ",
    "addedSuccess": "Đã thêm địa chỉ",
    "addError": "Thêm địa chỉ thất bại",
    "updatedSuccess": "Đã cập nhật địa chỉ",
    "updateError": "Cập nhật địa chỉ thất bại",
    "removedSuccess": "Đã xóa địa chỉ",
    "removeError": "Xóa địa chỉ thất bại",
    "requiredError": "Địa chỉ dòng 1 và quốc gia là bắt buộc",
    "confirmRemoveTitle": "Xóa địa chỉ",
    "confirmRemoveMessage": "Bạn có chắc muốn xóa địa chỉ {{type}} này?",
    "confirmRemoveLabel": "Xóa"
  },
  "allergies": {
    "pageTitle": "Dị ứng",
    "addAllergy": "Thêm dị ứng",
    "loading": "Đang tải thông tin dị ứng...",
    "loadError": "Không tải được thông tin dị ứng.",
    "nka": {
      "title": "Không có dị ứng đã biết (NKA)",
      "body": "Bệnh nhân này chưa ghi nhận dị ứng nào."
    },
    "sections": {
      "active": "Dị ứng đang hoạt động ({{count}})",
      "inactive": "Dị ứng không hoạt động ({{count}})"
    },
    "fields": {
      "reaction": "Phản ứng",
      "severity": "Mức độ",
      "onset": "Khởi phát",
      "recorded": "Ngày ghi nhận"
    },
    "inactiveSummary": "Phản ứng: {{reaction}} | Mức độ: {{severity}}",
    "deactivate": "Tạm ngừng",
    "deactivateTooltip": "Tạm ngừng dị ứng",
    "deleteTooltip": "Xóa dị ứng",
    "deactivatedSuccess": "Đã tạm ngừng dị ứng",
    "deactivateError": "Tạm ngừng dị ứng thất bại",
    "removedSuccess": "Đã xóa dị ứng",
    "removeError": "Xóa dị ứng thất bại",
    "confirmDeactivateTitle": "Xác nhận tạm ngừng",
    "confirmDeactivateMessage": "Bạn có chắc muốn tạm ngừng \"{{name}}\"?",
    "confirmDeleteTitle": "Xác nhận xóa",
    "confirmDeleteMessage": "Bạn có chắc muốn xóa vĩnh viễn \"{{name}}\"?",
    "confirmLabel": "Xác nhận"
  },
  "problems": {
    "pageTitle": "Danh sách vấn đề",
    "addProblem": "Thêm vấn đề",
    "loading": "Đang tải danh sách vấn đề...",
    "loadError": "Không tải được danh sách vấn đề.",
    "tabs": {
      "active": "Đang hoạt động ({{count}})",
      "resolvedInactive": "Đã giải quyết / Không hoạt động ({{count}})"
    },
    "sortByLabel": "Sắp xếp:",
    "sortBy": {
      "onsetDate": "Ngày khởi phát",
      "severity": "Mức độ"
    },
    "status": {
      "label": "Trạng thái",
      "values": {
        "active": "Đang hoạt động",
        "resolved": "Đã giải quyết",
        "inactive": "Không hoạt động"
      }
    },
    "empty": {
      "active": "Chưa ghi nhận vấn đề đang hoạt động.",
      "resolved": "Chưa có vấn đề đã giải quyết hoặc không hoạt động."
    },
    "fields": {
      "onset": "Khởi phát",
      "resolved": "Giải quyết"
    },
    "resolveButton": "Giải quyết",
    "reactivateButton": "Kích hoạt lại",
    "resolveTooltip": "Đánh dấu đã giải quyết",
    "reactivateTooltip": "Kích hoạt lại",
    "statusUpdatedSuccess": "Đã cập nhật trạng thái vấn đề",
    "statusUpdateError": "Cập nhật trạng thái vấn đề thất bại"
  },
  "immunizations": {
    "pageTitle": "Tiêm chủng",
    "addImmunization": "Thêm tiêm chủng",
    "loading": "Đang tải hồ sơ tiêm chủng...",
    "loadError": "Không tải được hồ sơ tiêm chủng.",
    "empty": "Không tìm thấy hồ sơ tiêm chủng.",
    "dueOverdue": "Đến hạn / Quá hạn tiêm chủng ({{count}})",
    "upcoming": "Tiêm chủng sắp tới ({{count}})",
    "dueLabel": "Hạn: {{date}}",
    "fromDateLabel": "Từ ngày",
    "toDateLabel": "Đến ngày",
    "fromDateAria": "Ngày tiêm chủng bắt đầu",
    "toDateAria": "Ngày tiêm chủng kết thúc",
    "clearFilters": "Xóa",
    "cvxLabel": "CVX: {{code}}",
    "columns": {
      "vaccine": "Vắc xin",
      "date": "Ngày tiêm",
      "lotNumber": "Số lô",
      "site": "Vị trí",
      "administeredBy": "Người tiêm",
      "nextDue": "Lần kế tiếp",
      "status": "Trạng thái"
    },
    "dueStatus": {
      "label": "Trạng thái",
      "values": {
        "overdue": "Quá hạn",
        "dueToday": "Đến hạn hôm nay",
        "upcoming": "Sắp tới"
      }
    }
  },
  "contacts": {
    "pageTitle": "Người liên hệ",
    "addContact": "Thêm liên hệ",
    "loading": "Đang tải liên hệ...",
    "loadError": "Không tải được thông tin liên hệ.",
    "empty": "Chưa có liên hệ nào.",
    "emergencyBadge": "Khẩn cấp",
    "sections": {
      "emergency": "Liên hệ khẩn cấp ({{count}})",
      "other": "Liên hệ khác ({{count}})"
    },
    "editTooltip": "Sửa liên hệ",
    "deleteTooltip": "Xóa liên hệ",
    "deletedSuccess": "Đã xóa liên hệ",
    "deleteError": "Xóa liên hệ thất bại",
    "confirmDeleteTitle": "Xóa liên hệ",
    "confirmDeleteMessage": "Bạn có chắc muốn xóa \"{{name}}\"?",
    "confirmDeleteLabel": "Xóa"
  },
  "insurances": {
    "pageTitle": "Bảo hiểm",
    "addInsurance": "Thêm bảo hiểm",
    "loading": "Đang tải thông tin bảo hiểm...",
    "loadError": "Không tải được thông tin bảo hiểm.",
    "empty": {
      "title": "Không có gói bảo hiểm",
      "body": "Bệnh nhân chưa được ghi nhận gói bảo hiểm nào."
    },
    "sections": {
      "active": "Gói đang hoạt động ({{count}})",
      "inactive": "Gói không hoạt động ({{count}})"
    },
    "status": {
      "label": "Trạng thái",
      "values": {
        "active": "Đang hoạt động",
        "inactive": "Không hoạt động",
        "pendingVerification": "Chờ xác minh"
      }
    },
    "fields": {
      "memberId": "Mã thành viên",
      "groupNumber": "Số nhóm",
      "effectiveDate": "Ngày hiệu lực",
      "terminationDate": "Ngày kết thúc",
      "copay": "Đồng chi trả",
      "coinsurance": "Đồng bảo hiểm",
      "deductible": "Mức khấu trừ",
      "subscriber": "Người tham gia"
    },
    "preAuthBadge": "Yêu cầu phê duyệt trước",
    "lastVerifiedLabel": "Xác minh gần nhất: {{date}}",
    "copayAmount": "${{amount}}",
    "coinsurancePercent": "{{percent}}%",
    "deductibleAmount": "${{amount}}",
    "verifyButton": "Xác minh",
    "verifyTooltip": "Xác minh quyền lợi",
    "editButton": "Sửa",
    "verifySuccess": "Đã khởi tạo xác minh quyền lợi",
    "verifyError": "Xác minh quyền lợi thất bại"
  },
  "identifiersTab": {
    "pageTitle": "Mã định danh",
    "addIdentifier": "Thêm mã định danh",
    "loading": "Đang tải mã định danh...",
    "loadError": "Không tải được thông tin mã định danh.",
    "empty": "Chưa có mã định danh nào.",
    "newTitle": "Mã định danh mới",
    "type": {
      "label": "Loại",
      "selectPlaceholder": "Chọn loại...",
      "values": {
        "externalMrn": "MRN ngoại viện",
        "insuranceId": "Mã bảo hiểm",
        "studyId": "Mã nghiên cứu",
        "healthCard": "Thẻ y tế",
        "nationalRegistry": "Đăng ký quốc gia",
        "passport": "Hộ chiếu",
        "driverLicense": "Bằng lái xe",
        "other": "Khác"
      }
    },
    "fields": {
      "value": "Giá trị",
      "assigningAuthority": "Cơ quan cấp",
      "effectiveDate": "Ngày hiệu lực",
      "expiryDate": "Ngày hết hạn"
    },
    "placeholders": {
      "value": "ví dụ: 012345678",
      "assigningAuthority": "ví dụ: Bộ Y tế"
    },
    "status": {
      "label": "Trạng thái",
      "values": {
        "active": "Đang hoạt động",
        "inactive": "Không hoạt động"
      }
    },
    "columns": {
      "type": "Loại",
      "value": "Giá trị",
      "assigningAuthority": "Cơ quan cấp",
      "effectiveDate": "Ngày hiệu lực",
      "expiryDate": "Ngày hết hạn",
      "status": "Trạng thái",
      "actions": "Thao tác"
    },
    "save": "Lưu",
    "cancel": "Hủy",
    "removeTooltip": "Xóa mã định danh",
    "addedSuccess": "Đã thêm mã định danh",
    "addError": "Thêm mã định danh thất bại",
    "removedSuccess": "Đã xóa mã định danh",
    "removeError": "Xóa mã định danh thất bại",
    "requiredError": "Loại và giá trị là bắt buộc",
    "confirmRemoveTitle": "Xóa mã định danh",
    "confirmRemoveMessage": "Bạn có chắc muốn xóa \"{{type}}: {{value}}\"?",
    "confirmRemoveLabel": "Xóa"
  },
  "pages": {
    "advanceDirectives": {
      "title": "Chỉ thị Y tế trước",
      "addButton": "Thêm chỉ thị",
      "emptyState": "Chưa có chỉ thị y tế trước nào được ghi nhận cho bệnh nhân này.",
      "loading": "Đang tải chỉ thị y tế trước...",
      "loadError": "Không thể tải chỉ thị y tế trước.",
      "documentLink": "Xem tài liệu",
      "effectivePrefix": "Hiệu lực:",
      "reviewPrefix": "Xem xét:",
      "form": {
        "title": "Chỉ thị Y tế trước mới",
        "labels": {
          "directiveType": "Loại chỉ thị",
          "status": "Trạng thái",
          "effectiveDate": "Ngày hiệu lực",
          "notes": "Ghi chú",
          "optional": "tùy chọn"
        },
        "placeholders": {
          "notes": "Ghi chú bổ sung về chỉ thị..."
        },
        "selectTypePlaceholder": "Chọn loại...",
        "aria": {
          "effectiveDate": "Ngày hiệu lực"
        },
        "buttons": {
          "save": "Lưu chỉ thị",
          "cancel": "Hủy"
        }
      },
      "directiveType": {
        "DNR": "Không hồi sức (DNR)",
        "living-will": "Di chúc sống",
        "POLST": "POLST / MOLST",
        "healthcare-proxy": "Người đại diện y tế",
        "power-of-attorney": "Ủy quyền bền vững"
      },
      "directiveStatus": {
        "active": "Hiệu lực",
        "inactive": "Không hiệu lực",
        "revoked": "Đã thu hồi",
        "pending": "Chờ xem xét"
      },
      "toast": {
        "added": "Đã thêm chỉ thị y tế trước",
        "addFailed": "Không thể thêm chỉ thị y tế trước",
        "directiveTypeRequired": "Loại chỉ thị là bắt buộc"
      }
    },
    "familyHistory": {
      "title": "Tiền sử Gia đình",
      "addButton": "Thêm Mục",
      "emptyState": "Không có tiền sử gia đình nào được ghi nhận cho bệnh nhân này.",
      "loading": "Đang tải tiền sử gia đình...",
      "loadError": "Không thể tải tiền sử gia đình.",
      "onsetAge": "Tuổi khởi phát: {{age}} tuổi",
      "outcomePrefix": "Kết cục:",
      "form": {
        "title": "Mục Tiền sử Gia đình Mới",
        "labels": {
          "relationship": "Quan hệ",
          "conditionName": "Tên bệnh",
          "conditionCode": "Mã bệnh",
          "onsetAge": "Tuổi khởi phát",
          "outcome": "Kết cục",
          "optional": "tùy chọn"
        },
        "placeholders": {
          "onsetAge": "Tuổi (năm)"
        },
        "selectRelationshipPlaceholder": "Chọn quan hệ...",
        "selectOutcomePlaceholder": "Chọn kết cục...",
        "buttons": {
          "save": "Lưu Mục",
          "cancel": "Hủy"
        }
      },
      "relationship": {
        "Mother": "Mẹ",
        "Father": "Cha",
        "Sibling": "Anh chị em ruột",
        "Maternal Grandmother": "Bà ngoại",
        "Maternal Grandfather": "Ông ngoại",
        "Paternal Grandmother": "Bà nội",
        "Paternal Grandfather": "Ông nội",
        "Child": "Con",
        "Aunt": "Cô/Dì/Mợ/Thím",
        "Uncle": "Chú/Bác/Cậu/Dượng"
      },
      "outcome": {
        "alive": "Còn sống",
        "deceased": "Đã mất",
        "unknown": "Không rõ"
      },
      "toast": {
        "added": "Đã thêm mục tiền sử gia đình",
        "addFailed": "Không thể thêm mục tiền sử gia đình",
        "relationshipAndConditionRequired": "Quan hệ và tên bệnh là bắt buộc"
      }
    },
    "socialHistory": {
      "title": "Tiền sử xã hội",
      "editButton": "Chỉnh sửa",
      "loading": "Đang tải tiền sử xã hội...",
      "loadError": "Không thể tải tiền sử xã hội.",
      "labels": {
        "smokingStatus": "Tình trạng hút thuốc",
        "alcoholUse": "Sử dụng rượu",
        "substanceUse": "Sử dụng chất",
        "housing": "Nhà ở",
        "employment": "Việc làm",
        "safetyScreening": "Sàng lọc an toàn",
        "notes": "Ghi chú"
      },
      "placeholders": {
        "notes": "Ghi chú bổ sung..."
      },
      "buttons": {
        "save": "Lưu thay đổi",
        "cancel": "Hủy"
      },
      "toast": {
        "updated": "Đã cập nhật tiền sử xã hội",
        "updateFailed": "Không thể cập nhật tiền sử xã hội"
      },
      "smokingStatus": {
        "never": "Chưa từng hút thuốc",
        "former": "Đã từng hút thuốc",
        "currentDaily": "Đang hút thuốc hàng ngày",
        "currentOccasional": "Đang hút thuốc thỉnh thoảng",
        "unknown": "Không rõ"
      },
      "alcoholUse": {
        "None": "Không",
        "Social/Occasional": "Xã giao/Thỉnh thoảng",
        "Moderate": "Vừa phải",
        "Heavy": "Nhiều",
        "In Recovery": "Đang phục hồi",
        "Unknown": "Không rõ"
      },
      "substanceUse": {
        "None": "Không",
        "Current Use": "Đang sử dụng",
        "Former Use": "Đã từng sử dụng",
        "In Treatment": "Đang điều trị",
        "Unknown": "Không rõ"
      },
      "housing": {
        "Stable": "Ổn định",
        "Unstable": "Không ổn định",
        "Homeless": "Vô gia cư",
        "Assisted Living": "Sống có hỗ trợ",
        "Nursing Facility": "Cơ sở chăm sóc",
        "Unknown": "Không rõ"
      },
      "employment": {
        "Employed Full-Time": "Làm việc toàn thời gian",
        "Employed Part-Time": "Làm việc bán thời gian",
        "Self-Employed": "Tự kinh doanh",
        "Unemployed": "Thất nghiệp",
        "Retired": "Đã nghỉ hưu",
        "Student": "Học sinh/Sinh viên",
        "Disabled": "Khuyết tật không thể làm việc",
        "Unknown": "Không rõ"
      },
      "safetyScreening": {
        "No Concerns": "Không có lo ngại",
        "Concerns Identified": "Đã xác định lo ngại",
        "Declined to Answer": "Từ chối trả lời",
        "Not Screened": "Chưa sàng lọc"
      }
    },
    "surgicalHistory": {
      "title": "Tiền sử phẫu thuật",
      "addButton": "Thêm phẫu thuật",
      "emptyState": "Không có tiền sử phẫu thuật được ghi nhận cho bệnh nhân này.",
      "loading": "Đang tải tiền sử phẫu thuật...",
      "loadError": "Không thể tải tiền sử phẫu thuật.",
      "cptLabel": "CPT {{code}}",
      "dateLabel": "Ngày: {{date}}",
      "surgeonLabel": "Phẫu thuật viên: {{name}}",
      "anesthesiaLabel": "Gây mê: {{type}}",
      "outcomePrefix": "Kết quả:",
      "complicationsPrefix": "Biến chứng:",
      "form": {
        "title": "Mục tiền sử phẫu thuật mới",
        "labels": {
          "procedureName": "Tên phẫu thuật",
          "procedureCode": "Mã phẫu thuật",
          "procedureCodeSuffix": "(CPT)",
          "date": "Ngày",
          "surgeonName": "Tên phẫu thuật viên",
          "anesthesiaType": "Loại gây mê",
          "laterality": "Bên",
          "outcome": "Kết quả",
          "complications": "Biến chứng"
        },
        "placeholders": {
          "surgeonName": "Tên phẫu thuật viên",
          "complications": "Biến chứng nếu có..."
        },
        "selectPlaceholder": "Chọn...",
        "aria": {
          "procedureDate": "Ngày phẫu thuật"
        },
        "buttons": {
          "save": "Lưu mục",
          "cancel": "Hủy"
        }
      },
      "anesthesiaType": {
        "general": "Gây mê toàn thân",
        "regional": "Gây tê vùng",
        "local": "Gây tê tại chỗ",
        "spinal": "Gây tê tủy sống",
        "epidural": "Gây tê ngoài màng cứng",
        "sedation": "An thần",
        "none": "Không",
        "unknown": "Không rõ"
      },
      "laterality": {
        "left": "Trái",
        "right": "Phải",
        "bilateral": "Hai bên"
      },
      "toast": {
        "added": "Đã thêm mục tiền sử phẫu thuật",
        "addFailed": "Không thể thêm mục tiền sử phẫu thuật",
        "procedureNameRequired": "Bắt buộc nhập tên phẫu thuật"
      }
    },
    "referralManagement": {
      "title": "Chuyển tuyến",
      "addButton": "Chuyển tuyến mới",
      "refresh": "Làm mới",
      "loading": "Đang tải chuyển tuyến...",
      "errorState": "Không thể tải chuyển tuyến.",
      "emptyState": "Bệnh nhân này chưa có chuyển tuyến.",
      "emptyStateFiltered": "Không có chuyển tuyến nào khớp với trạng thái đã chọn.",
      "ariaFilterStatus": "Lọc chuyển tuyến theo trạng thái",
      "externalBadge": "Bên ngoài",
      "filterStatus": {
        "allLabel": "Tất cả trạng thái"
      },
      "table": {
        "type": "Loại",
        "reason": "Lý do",
        "specialty": "Chuyên khoa",
        "priority": "Mức ưu tiên",
        "status": "Trạng thái",
        "requested": "Ngày yêu cầu",
        "target": "Ngày mục tiêu"
      },
      "form": {
        "title": "Chuyển tuyến mới",
        "labels": {
          "referralType": "Loại chuyển tuyến",
          "priority": "Mức ưu tiên",
          "specialty": "Chuyên khoa",
          "reason": "Lý do",
          "targetDate": "Ngày mục tiêu",
          "clinicalNotes": "Ghi chú lâm sàng",
          "optional": "không bắt buộc"
        },
        "placeholders": {
          "reason": "Lý do chuyển tuyến",
          "clinicalNotes": "Ghi chú lâm sàng bổ sung..."
        },
        "selectReferralTypePlaceholder": "Chọn loại...",
        "selectSpecialtyPlaceholder": "Chọn chuyên khoa...",
        "buttons": {
          "create": "Tạo chuyển tuyến",
          "cancel": "Hủy"
        }
      },
      "referralType": {
        "consultation": "Hội chẩn",
        "transfer": "Chuyển viện",
        "second-opinion": "Ý kiến thứ hai",
        "diagnostic": "Chẩn đoán",
        "therapeutic": "Điều trị"
      },
      "priority": {
        "routine": "Thường quy",
        "urgent": "Khẩn",
        "stat": "STAT"
      },
      "status": {
        "draft": "Bản nháp",
        "submitted": "Đã gửi",
        "accepted": "Đã chấp nhận",
        "scheduled": "Đã lên lịch",
        "completed": "Hoàn thành",
        "cancelled": "Đã hủy"
      },
      "toasts": {
        "createSuccess": "Đã tạo chuyển tuyến",
        "createFailed": "Không thể tạo chuyển tuyến",
        "validationFailed": "Bắt buộc nhập loại chuyển tuyến và lý do"
      }
    }
  },
  "consents": {
    "title": "Consents",
    "grant": "Grant consent",
    "revoke": "Revoke",
    "confirmRevoke": "Revoke this consent? This records a revocation event and cannot be undone.",
    "loading": "Loading consents…",
    "loadError": "Failed to load consents.",
    "empty": "No consent records for this patient.",
    "table": {
      "scope": "Scope",
      "category": "Category",
      "decision": "Decision",
      "status": "Status",
      "effective": "Effective",
      "recorded": "Recorded",
      "actions": "Actions",
      "history": "Event history"
    },
    "toast": {
      "revoked": "Consent revoked.",
      "revokeFailed": "Failed to revoke consent."
    },
    "scope": {
      "patientPrivacy": "Patient privacy",
      "research": "Research",
      "treatment": "Treatment",
      "adr": "Adverse drug reaction"
    },
    "decision": {
      "permit": "Permit",
      "deny": "Deny"
    },
    "status": {
      "draft": "Draft",
      "proposed": "Proposed",
      "active": "Active",
      "rejected": "Rejected",
      "inactive": "Inactive",
      "enteredInError": "Entered in error"
    },
    "eventType": {
      "granted": "Granted",
      "revoked": "Revoked",
      "evaluated": "Evaluated",
      "accessGranted": "Access granted",
      "accessDenied": "Access denied"
    },
    "events": {
      "loading": "Loading history…",
      "empty": "No events recorded."
    },
    "form": {
      "title": "Grant consent",
      "submit": "Grant consent",
      "savedSuccess": "Consent recorded.",
      "saveError": "Failed to record consent."
    },
    "fields": {
      "scope": "Scope",
      "decision": "Decision",
      "category": "Category",
      "categoryPlaceholder": "e.g. medical-records, imaging",
      "performer": "Performer",
      "performerPlaceholder": "e.g. Patient/123 or Practitioner/45",
      "purpose": "Purpose",
      "dataClass": "Data class",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "notes": "Notes"
    }
  },
  "pregnancy": {
    "title": "Pregnancy & Lactation Screening",
    "currentHeading": "Current status",
    "recordHeading": "Record a status",
    "historyHeading": "History",
    "pregnancyLabel": "Pregnancy",
    "lactationLabel": "Lactation",
    "eddLabel": "Estimated due date",
    "sourceLabel": "Source",
    "notesLabel": "Notes",
    "recordButton": "Record status",
    "recordedOn": "Recorded {{date}}",
    "eddOn": "Estimated due date {{date}}",
    "outOfDate": "Out of date",
    "neverAsked": "Never asked",
    "notRecorded": "Not recorded",
    "noHistory": "No screening has been recorded for this patient.",
    "savedSuccess": "Screening status recorded",
    "saveError": "Could not record the screening status",
    "status": {
      "pregnant": "Pregnant",
      "notPregnant": "Not pregnant",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "lactationStatus": {
      "lactating": "Lactating",
      "notLactating": "Not lactating",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "source": {
      "patientReported": "Patient reported",
      "clinician": "Clinician",
      "lab": "Laboratory"
    },
    "columns": {
      "recordedAt": "Recorded",
      "pregnancy": "Pregnancy",
      "lactation": "Lactation",
      "edd": "Due date",
      "source": "Source",
      "notes": "Notes"
    },
    "errors": {
      "notesTooLong": "Notes must be 1000 characters or fewer",
      "eddOnlyWhenPregnant": "An estimated due date applies only to a pregnant status"
    }
  },
  "nursingAssessment": {
    "title": "Nursing Assessment",
    "subtitle": "The Morse and Braden scores recorded here update this patient's risk badges.",
    "assessmentType": "Assessment type",
    "type": {
      "admission": "Admission",
      "shift": "Shift",
      "focused": "Focused",
      "discharge": "Discharge"
    },
    "levelOfConsciousness": "Level of consciousness",
    "loc": {
      "alert": "Alert",
      "drowsy": "Drowsy",
      "lethargic": "Lethargic",
      "confused": "Confused",
      "unresponsive": "Unresponsive"
    },
    "mobilityLevel": "Mobility",
    "mobility": {
      "independent": "Independent",
      "assistiveDevice": "Assistive device",
      "assistOfOne": "Assist of one",
      "assistOfTwo": "Assist of two",
      "bedbound": "Bedbound"
    },
    "fallRiskFactors": "Fall risk factors",
    "fallRiskFactorsPlaceholder": "e.g. unsteady gait, IV pole, sedation",
    "pressureInjuryPresent": "Pressure injury already present",
    "painAssessment": "Pain assessment",
    "painPlaceholder": "Site, character, score, intervention",
    "generalNotes": "General notes",
    "save": "Save assessment",
    "saving": "Saving…",
    "saved": "Assessment recorded",
    "saveFailed": "Could not record the assessment",
    "notClinical": "Your account has no clinical identity, so it cannot sign a nursing assessment.",
    "history": "Previous assessments",
    "historyEmpty": "No assessments recorded for this encounter yet.",
    "bands": "Fall: {{fall}} · Pressure: {{pressure}}",
    "notScored": "not scored"
  },
  "duplicates": {
    "title": "Duplicate Review",
    "subtitle": "Candidate duplicate records found by the matching scanner. Review each pair and merge, or record that they are different people.",
    "noPermission": "You do not have permission to review duplicate patient records.",
    "loading": "Loading candidates...",
    "loadFailed": "Could not load the duplicate worklist.",
    "empty": "No candidates to review.",
    "dismissed": "Decision recorded.",
    "dismissFailed": "Could not record the decision.",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{totalPages}}",
    "columns": {
      "score": "Score",
      "patients": "Records",
      "matchedOn": "Matched on",
      "detected": "Detected",
      "actions": "Actions"
    },
    "filters": {
      "status": "Review status",
      "minScore": "Min score"
    },
    "status": {
      "pending": "Pending",
      "reviewed": "Reviewed",
      "merged": "Merged",
      "not_duplicate": "Not a duplicate",
      "ignored": "Ignored"
    },
    "confidence": {
      "very_high": "Very high",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "matchedField": {
      "nameMatch": "Name",
      "dobMatch": "Date of birth",
      "genderMatch": "Gender",
      "nationalIdMatch": "National ID",
      "phoneMatch": "Phone",
      "addressMatch": "Address"
    },
    "actions": {
      "review": "Review",
      "dismiss": "Not a duplicate"
    },
    "dismissDialog": {
      "title": "Record a review decision",
      "body": "{{name1}} ({{mrn1}}) and {{name2}} ({{mrn2}}) will be removed from the worklist.",
      "reasonHelp": {
        "not_duplicate": "These are different people. The pair will not return unless the matching evidence materially improves.",
        "ignored": "Do not action this pair for now. Same suppression rule applies."
      },
      "notesPlaceholder": "Notes (optional)",
      "cancel": "Cancel",
      "confirm": "Record decision"
    },
    "restricted": {
      "title_one": "Có {{count}} cặp liên quan đến bệnh nhân mà bạn không có quyền xem",
      "title_other": "Có {{count}} cặp liên quan đến bệnh nhân mà bạn không có quyền xem",
      "body": "Một bệnh nhân của bạn có thể trùng với hồ sơ tại cơ sở khác. Cặp này không được liệt kê vì để đánh giá cần xem bệnh nhân ngoài quyền truy cập của bạn — hãy đề nghị bộ phận Quản lý Thông tin Y tế xem xét."
    }
  },
  "__review_duplicateReview": "Duplicate-review worklist copy — ships English pending market sign-off; 'merge' vs 'link' is a records-management register that differs by market.",
  "recordExport": {
    "button": "Xuất hồ sơ",
    "exporting": "Đang xuất…",
    "success": "Đã xuất hồ sơ",
    "failed": "Xuất thất bại — không có gì được tải xuống",
    "tooltip": "Tải xuống hồ sơ đầy đủ của bệnh nhân này dưới dạng tệp di động"
  },
  "device": {
    "addTitle": "Ghi nhận thiết bị cấy ghép",
    "editTitle": "Ghi nhận tháo bỏ",
    "deviceName": "Tên thiết bị",
    "deviceNamePlaceholder": "vd: Evera MRI ICD, stent phủ thuốc",
    "deviceNameTooLong": "Tên thiết bị tối đa 512 ký tự",
    "deviceType": "Loại thiết bị",
    "deviceTypePlaceholder": "vd: máy tạo nhịp tim, stent, chi giả",
    "udi": "UDI",
    "udiPlaceholder": "Mã định danh thiết bị duy nhất",
    "deviceCode": "Mã thiết bị",
    "deviceCodeSystem": "Hệ mã",
    "deviceCodeSystemPlaceholder": "vd: GMDN, SNOMED CT",
    "manufacturer": "Nhà sản xuất",
    "modelNumber": "Model",
    "lotNumber": "Số lô",
    "serialNumber": "Số sê-ri",
    "implantDate": "Ngày cấy ghép",
    "explantDate": "Ngày tháo bỏ",
    "status": "Trạng thái",
    "statusOptions": {
      "active": "Đang dùng",
      "inactive": "Ngừng dùng",
      "explanted": "Đã tháo"
    },
    "mriSafety": "An toàn MRI",
    "mriSafetyOptions": {
      "safe": "An toàn",
      "conditional": "Có điều kiện",
      "unsafe": "Không an toàn",
      "unknown": "Không rõ"
    },
    "notes": "Ghi chú",
    "notesPlaceholder": "Ghi chú thêm...",
    "savedSuccess": "Ghi nhận thiết bị thành công",
    "saveError": "Ghi nhận thiết bị thất bại",
    "updatedSuccess": "Ghi nhận tháo bỏ thành công",
    "updateError": "Ghi nhận tháo bỏ thất bại",
    "explantRequiresDate": "Thiết bị đã tháo cần có ngày tháo bỏ",
    "explantBeforeImplant": "Ngày tháo bỏ không được trước ngày cấy ghép"
  },
  "devices": {
    "pageTitle": "Thiết bị cấy ghép",
    "addDevice": "Ghi nhận thiết bị",
    "loading": "Đang tải thiết bị...",
    "loadError": "Tải thông tin thiết bị thất bại.",
    "empty": {
      "title": "Không có thiết bị cấy ghép",
      "body": "Chưa ghi nhận thiết bị nào cho bệnh nhân này."
    },
    "sections": {
      "active": "Thiết bị đang dùng ({{count}})",
      "history": "Đã tháo / Ngừng dùng ({{count}})"
    },
    "fields": {
      "udi": "UDI",
      "manufacturer": "Nhà sản xuất",
      "implanted": "Ngày cấy",
      "explanted": "Ngày tháo",
      "mriSafety": "An toàn MRI",
      "recorded": "Ngày ghi"
    },
    "recordExplant": "Ghi nhận tháo bỏ",
    "explantTooltip": "Ghi nhận việc tháo thiết bị này",
    "removeTooltip": "Xóa mục",
    "removedSuccess": "Đã xóa mục thiết bị",
    "removeError": "Xóa mục thiết bị thất bại",
    "confirmDeleteTitle": "Xác nhận xóa",
    "confirmDeleteMessage": "Xóa \"{{name}}\" khỏi danh sách? Chỉ xóa các mục ghi nhầm — để ghi nhận việc lấy ra khỏi cơ thể, hãy dùng Ghi nhận tháo bỏ.",
    "confirmLabel": "Xác nhận"
  },
  "ccdaImports": {
    "title": "Nhập C-CDA",
    "subtitle": "Tài liệu đã nhận chờ đối chiếu. Mở một bản nhập để duyệt từng mục vào hồ sơ.",
    "empty": "Chưa có tài liệu nhập nào cho bệnh nhân này.",
    "loadError": "Không thể tải các bản nhập.",
    "received": "Đã nhận",
    "docType": "Loại",
    "status": "Trạng thái",
    "pending": "Chờ xử lý",
    "entries": "Mục",
    "match": "Khớp",
    "mismatch": "ID không khớp",
    "statuses": {
      "pending": "Chờ xử lý",
      "reviewed": "Đã duyệt",
      "dismissed": "Đã bỏ"
    },
    "docTypes": {
      "ccd": "CCD",
      "referral-note": "Giấy giới thiệu",
      "discharge-summary": "Tóm tắt ra viện",
      "other": "Khác"
    }
  },
  "ccdaReview": {
    "title": "Bản nhập #{{id}}",
    "back": "Về danh sách nhập",
    "loadError": "Không thể tải bản nhập này.",
    "mismatchWarning": "Định danh người gửi không khớp bệnh nhân này. Hãy xác minh tài liệu thuộc về đúng người trước khi chấp nhận.",
    "unnamed": "Mục chưa đặt tên",
    "accept": "Chấp nhận",
    "reject": "Từ chối",
    "accepted": "Đã hợp nhất mục vào hồ sơ",
    "rejected": "Đã từ chối mục",
    "alreadyReviewed": "Người khác đã duyệt — đã làm mới bên dưới",
    "reviewError": "Duyệt thất bại",
    "confirmAcceptTitle": "Chấp nhận vào hồ sơ?",
    "confirmAcceptMessage": "“{{name}}” sẽ được thêm vào hồ sơ bệnh nhân này.",
    "confirmRejectTitle": "Từ chối mục này?",
    "confirmRejectMessage": "“{{name}}” sẽ bị loại khỏi hàng đợi. Tài liệu gốc vẫn được lưu.",
    "sections": {
      "problem": "Vấn đề",
      "medication": "Thuốc",
      "allergy": "Dị ứng"
    },
    "statuses": {
      "accepted": "Đã chấp nhận",
      "rejected": "Đã từ chối"
    }
  }
}
